@use "../../styles/breakpoint" as *;

.root {
    overflow: hidden;
    position: relative;
}

.columnWrapper {
    position: absolute;
    top: 0;
    width: 100%;
}

.columnContainer {
    composes: container from "../../styles/composable/layout.module.css";
    align-items: stretch;
    display: flex;

    @media ($below-mobile) {
        flex-direction: column;
    }
}

.backgroundMedia {
    & > picture > img {
        display: block;
        height: 100%;
        object-fit: cover;
        width: 100%;
        z-index: -1;

        @media ($above-mobile) {
            min-height: 30rem;
        }

        @media ($below-mobile) {
            height: auto;
        }
    }
}

.backgroundVideo {
    display: block;
    height: auto;
    width: 100%;
}

.stackOnMobile {
    @media ($below-mobile) {
        margin-top: 0;
        position: relative;
        top: 0;
    }
}

.column {
    flex: 1;
    padding: 1vw;
}

.columnImage {
    height: auto;
    margin: 0 auto 10px;
    max-width: 100%;
    padding: 0;
}

.valueProp {
    align-items: center;
    display: flex;
}

.valuePropImage {
    margin-right: 16px;
    width: 72px;
}

.soloBoxLeft {
    composes: gridContainer from "../../styles/composable/layout.module.css";
    padding: 92px 0;

    @media ($below-mobile) {
        --labui-container-margin: 0;

        padding: 0;
    }

    & > div {
        background-color: rgb(var(--white-base) / 90%);
        border-radius: 9px;
        grid-column: span 4;
        padding: 28px 25px;
        position: relative;
        z-index: 10;

        @media ($below-tablet) {
            grid-column: span 5;
        }

        @media ($below-mobile) {
            background-color: var(--white);
            border-radius: 0;
        }
    }
}

.soloBoxRight {
    composes: soloBoxLeft;

    & > div {
        grid-column: 9 / span 4;

        @media ($below-tablet) {
            grid-column: 8 / span 5;
        }

        @media ($below-mobile) {
            grid-column: span 12;
        }
    }
}

.soloTextLeft {
    composes: gridContainer from "../../styles/composable/layout.module.css";
    padding: 72px 0;

    @media ($below-mobile) {
        --labui-container-margin: 0;

        padding: 30px 50px;
    }

    & > div {
        grid-column: span 4;
        padding: 0;
        position: relative;
        z-index: 10;

        @media ($below-tablet) {
            grid-column: span 5;
        }
    }
}

.fixedIconSizeWrapper {
    .backgroundMedia {
        & > picture > img {
            position: absolute;
            top: 0;
            width: 100%;
        }
    }
}

.fixedIconSize {
    composes: container from "../../styles/composable/layout.module.css";
    display: flex;
    justify-content: center;
    text-align: center;

    @media ($below-tablet) {
        flex-wrap: wrap;
        padding: 3vw;
    }

    & > div {
        flex: unset;
    }

    & picture {
        display: inline-block;
        max-width: 100%;
    }
}
